<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import Swal from "sweetalert2";
import pdf from 'vue-pdf';
import DatePicker from "vue2-datepicker";
import Multiselect from 'vue-multiselect';
import moment from "moment";
/**
 * Starter component
 */
export default {
    components: { Layout, PageHeader, pdf, Multiselect, DatePicker },
    data() {
        return {
            title: "Revision gastos",
            items: [
                {
                text: "Utility",
                href: "/"
                },
                {
                text: "Starter Page",
                active: true
                }
            ],
            reembolsos:[],
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            filtro: '',
            direccion:'',
            extension:'',
            valor_editar:{
                evento:'',
                tipo:'',
                monto:'$0',
                imagen:[],
                fecha:'',
                colegio:''
            },
            tipos:['Transporte local/Nacional','Alimentos/bebidas reuniones','Peaje y estacionamiento','Gasolina','Materiales de oficina','Hospedaje','Viajes Aereos'],
            imagenminiatura:'',
            colegiosFiltrados:[],
            eventoscolegiosFiltrados:[],
            eventosFiltrados:[],
            archivoPreview: '',
            tipoArchivo: '',
            todoseventos:[],
            eventos:[],
            colegios:[],
            cambiar:false,
        };
    },
    computed:{
        rows() {
            return this.reembolsos.length;
        },
        filteredData() {
            // Filtramos los datos en base al campo 'filtro' 
            return this.reembolsos.filter((item) => {
                // Aquí puedes personalizar los campos a buscar
                return (
                    item.rut.toLowerCase().includes(this.filtro.toLowerCase()) ||
                    item.name.toLowerCase().includes(this.filtro.toLowerCase())
                );
            });
        },
        paginatedData() {
            const start = (this.currentPage - 1) * this.perPage;
            const end = start + this.perPage;
            return this.filteredData.slice(start, end)
        },
        totalPages() {
            return Math.ceil(this.filteredData.length / this.perPage);
        },
    },
    methods:{
        ver_mas(item){
            this.$set(item, 'boton', item.boton === 'Ver más' ? 'Ver menos' : 'Ver más');
        },
        ver_comprobante(item){
            if (item.imagen_url) {
                const extension = item.imagen_url.split('.').pop().toLowerCase();
                if (['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(extension)) {
                    this.direccion = item.imagen_url;
                    this.extension = '';
                } else if (extension === 'pdf') {
                    this.direccion = item.imagen_url;
                    this.extension = 'pdf';
                }
            }
            this.$refs['modal-imagen'].show();
        },
        aprobar_gasto(item){
            let formData = new FormData();
            formData.append('gasto_id', item.id);
            formData.append('status', item.status);
            axios.post('/api/seleccionar_gasto',formData).then(response => {
                this.msg('success','Aprobado')
            });
        },
        msg(tipo,titulo){
            Swal.fire({
                //position: "top-end",
                icon: tipo,
                title: titulo,
                //text: '',
                showConfirmButton: false,
                timer: 5000
            });
        },
        modal_editar(item){
            this.valor_editar.id = item.id;
            this.valor_editar.fecha = item.fecha;
            this.valor_editar.evento = this.todoseventos.filter(evento => evento.id==item.evento_id);
            this.valor_editar.colegio = this.colegios.filter(colegio => colegio.rbd==this.valor_editar.evento[0].rbd_colegio);
            this.valor_editar.monto = item.monto;
            this.valor_editar.tipo = item.tipo_gasto;
            if (item.imagen_url) {
                const extension = item.imagen_url.split('.').pop().toLowerCase();
                if (['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(extension)) {
                    this.direccion = item.imagen_url;
                    this.extension = '';
                } else if (extension === 'pdf') {
                    this.direccion = item.imagen_url;
                    this.extension = 'pdf';
                }
            }
            this.$refs['modal-editar'].show();
        },
        filtro_colegios() {
            if (!this.valor_editar.fecha) return;
            // Filtrar eventos por la fecha seleccionada
            this.eventoscolegiosFiltrados = this.eventos.filter(
                (evento) => moment(evento.fecha_inicio).format('YYYY-MM-DD') === this.valor_editar.fecha
            );
            // Extraer RBD únicos y asegurarnos de que sean cadenas para evitar problemas de comparación
            const rbdUnicos = [...new Set(this.eventoscolegiosFiltrados.map(evento => String(evento.rbd_colegio).trim()))];
            // Filtrar colegios con los RBD obtenidos
            this.colegiosFiltrados = this.colegios.filter(colegio => 
                rbdUnicos.includes(String(colegio.rbd).trim())
            );
        },
        filtro_eventos(){
            this.eventosFiltrados = this.eventoscolegiosFiltrados.filter(
                (evento) => evento.rbd_colegio == this.valor_editar.colegio.rbd
            );
        },
        disabledBeforeToday(date) {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            return date > today ;
        },
        labelEvento(evento) {
            return `${evento.codigo} - ${evento.nombre_difusion}`;
        },
        labelColegio(colegio) {
            return `${colegio.rbd} - ${colegio.nombre}`;
        },
        obtenerImagen(e){
            let file = e.target.files[0];
            if (!file) return;
            this.valor_editar.imagen = file;
            this.cargarImagen(file);
        },
        cargarImagen(file){
            let reader = new FileReader(); 
            // Verificar el tipo de archivo
            if (file.type.includes("image")) {
                this.tipoArchivo = "imagen";
            } else if (file.type.includes("pdf")) {
                this.tipoArchivo = "pdf";
            } else {
                this.tipoArchivo = "";
                return;
            }
            reader.onload = (e) => {
                this.imagenminiatura = e.target.result;
            };
            reader.readAsDataURL(file);
        },
        format_Valor(){
            this.valor_editar.monto=this.format_Valor_variable(this.valor_editar.monto);
        },
        format_Valor_variable(val){
            return val? parseInt(val.toString().replace(/[^0-9]/g, ''), 10)? parseInt(val.toString().replace(/[^0-9]/g, ''), 10).toLocaleString("es-CL", { style: "currency", currency: "CLP" }): '$0': '$0';
        },
        btn_cambiar(){
            this.cambiar=!this.cambiar;
        },
        editar(){
            let formData = new FormData();
            formData.append('id', this.valor_editar.id);
            formData.append('tipo', this.valor_editar.tipo);
            formData.append('monto', this.valor_editar.monto);
            formData.append('imagen', this.valor_editar.imagen);
            axios.post('/api/editar_gastos',formData).then(res=>{
                if(res.data.estado){
                    this.valor_editar.fecha='';
                    this.valor_editar.colegio='';
                    this.valor_editar.evento='';
                    this.valor_editar.tipo='';
                    this.valor_editar.monto='$0';
                    this.valor_editar.imagen=[];
                    this.imagenminiatura='';
                    this.tipoArchivo='';
                    this.msg('success','Gasto editado correctamente');
                    axios.get('/api/get_gastos').then(res=>{
                        this.reembolsos=res.data.eventos.filter((us) => us.boolean==true);
                    });
                }else{
                    this.msg('error','Gasto No editado');
                }
            });
        },
        eliminar(item){
            let formData = new FormData();
            formData.append('gasto_id', item.id);
            Swal.fire({
                title: "¿Está seguro que desea eliminar este gasto?",
                text: "¡No podrás revertir esto! ",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#C87838",
                cancelButtonColor: "#d33",
                confirmButtonText: "Si, estoy seguro"
            }).then((result) => {
                if (result.isConfirmed) {
                    axios.post('/api/eliminar_gastos',formData).then(response => {
                        if (response.data.estado) {
                            Swal.fire({
                                title: "Eliminado",
                                text: "La información ha sido borrada",
                                icon: "success",
                                showConfirmButton: false,
                                timer: 1000
                            });
                            axios.get('/api/get_gastos').then(res=>{
                                this.reembolsos=res.data.eventos.filter((us) => us.boolean==true);
                            });
                        }
                    });
                }
            });
        }
    },
    created(){
        axios.get('/api/get_gastos').then(res=>{
            this.reembolsos=res.data.eventos.filter((us) => us.boolean==true);
        });
        axios.get('/api/get_eventos').then(res=>{
            this.todoseventos=res.data.eventos
            this.eventos = res.data.eventos.filter(evento => new Date(evento.fecha_inicio) <= new Date());
        });
        axios.get(`/api/get_colegios`).then(response => {
            if(response.data.estado){
                this.colegios = response.data.colegios;
            }
        });
    }
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-12" v-if="reembolsos.length>0">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_length" class="dataTables_length">
                                    <label class="d-inline-flex align-items-center">
                                        Mostrar&nbsp;
                                        <b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select>&nbsp;recibos
                                    </label>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                                    <label class="d-inline-flex align-items-center">
                                        Buscar:
                                        <b-form-input
                                        v-model="filtro"
                                        type="search"
                                        placeholder="Buscar..."
                                        class="form-control form-control-sm ml-2"
                                        ></b-form-input>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="table-responsive mb-0 mt-3">
                            <table class="table ">
                                <thead>
                                    <tr>
                                        <th style="width: 5%;">Nº</th>
                                        <th style="width: 8%;">Evento</th>
                                        <th style="width: 10%;">Coordinador</th>
                                        <th style="width: 20%;">Acción</th>
                                    </tr>
                                </thead>
                            </table>
                        </div>
                        <div class="table-responsive" v-for="(item, index) in reembolsos" :key="index">
                            <table class="table">
                                <tbody>
                                    <tr>
                                        <td>{{ index+1 }}</td>
                                        <td>{{ item.codigo}}</td>
                                        <td>{{ item.coordinador_evento }}</td>
                                        <td>
                                            <b-button v-b-toggle="'accordion-'+item.id" variant="secondary" @click="ver_mas(item)">{{item.boton}}</b-button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <b-collapse :id="'accordion-'+item.id" accordion="my-accordion" role="tabpanel">
                                <div class="row">
                                    <div class="col-md-12" >
                                        <div class="card mt-3 shadow-sm border-light">
                                            <div class="card-body">
                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <div class="table-responsive mb-0 mt-3">
                                                            <table class="table ">
                                                                <thead>
                                                                    <tr>
                                                                        <th style="width: 5%;">Nº</th>
                                                                        <th style="width: 5%;">Seleccionar</th>
                                                                        <th style="width: 8%;">Tipo Gasto</th>
                                                                        <th style="width: 10%;">Monto</th>
                                                                        <th style="width: 20%;">Comprobante</th>
                                                                        <th style="width: 20%;">Acciones</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr v-for="(item2, index2) in item.gastos" :key="index2">
                                                                        <td>{{ index2+1 }}</td>
                                                                        <td>
                                                                            <b-form-checkbox
                                                                            :id="'checkbox-'+index2+'-'+index"
                                                                            v-model="item2.status"
                                                                            value="1"
                                                                            unchecked-value="0"
                                                                            @change="aprobar_gasto(item2)"
                                                                            >
                                                                            </b-form-checkbox>
                                                                        </td>
                                                                        <td>{{ item2.tipo_gasto}}</td>
                                                                        <td>{{ item2.monto }}</td>
                                                                        <td>
                                                                            <b-button variant="primary" @click="ver_comprobante(item2)" size="sm">Ver</b-button>
                                                                        </td>
                                                                        <td>
                                                                            <b-button variant="primary" @click="modal_editar(item2)">Editar</b-button>
                                                                            <b-button variant="danger" @click="eliminar(item2)"><i class="bx bx-trash"></i></b-button>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-collapse>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="dataTables_paginate paging_simple_numbers float-right">
                                    <ul class="pagination pagination-rounded mb-0">
                                        <!-- pagination -->
                                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <b-modal ref="modal-imagen" title="Comprobante de Gasto" ok-only ok-title="Cerrar">
                            <pdf :src="direccion" v-if="extension=='pdf'"></pdf>
                            <img :src="direccion" width="100%" v-else>
                        </b-modal>
                        <b-modal ref="modal-editar" title="Editar Gasto" ok-title="Guardar" cancel-title="Cancelar" @ok="editar">
                            <div class="row mt-4">
                                <div class="col-md-12">
                                    <div class="form-group row">
                                        <div class="col-md-6">
                                            <label for="pais"> Fecha:</label>
                                        </div>
                                        <div class="col-md-12">
                                            <date-picker v-model="valor_editar.fecha" value-type="YYYY-MM-DD" format="DD-MM-YYYY" :first-day-of-week="2" lang="es" :disabled-date="disabledBeforeToday" @change="filtro_colegios" disabled></date-picker>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group row">
                                        <div class="col-md-6">
                                            <label for="pais"> Colegio:</label>
                                        </div>
                                        <div class="col-md-12">
                                            <multiselect
                                                v-model="valor_editar.colegio"
                                                :options="colegiosFiltrados" 
                                                placeholder="Seleccionar colegio" 
                                                selectLabel="Presiona para seleccionar"
                                                selectedLabel="Seleccionado"
                                                deselectLabel="Presiona para remover"
                                                :custom-label="labelColegio"
                                                disabled
                                                @select="filtro_eventos"
                                                >
                                                <template v-slot:noOptions>
                                                    <p>No hay opciones</p>
                                                </template>
                                                <template v-slot:noResult>
                                                    <p>No se encuentra coincidencia</p>
                                                </template>
                                            </multiselect>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group row">
                                        <div class="col-md-6">
                                            <label for="pais"> Evento:</label>
                                        </div>
                                        <div class="col-md-12">
                                            <multiselect
                                                v-model="valor_editar.evento"
                                                :options="eventosFiltrados" 
                                                placeholder="Seleccionar evento" 
                                                selectLabel="Presiona para seleccionar"
                                                selectedLabel="Seleccionado"
                                                deselectLabel="Presiona para remover"
                                                :custom-label="labelEvento"
                                                disabled
                                                >
                                                <template v-slot:noOptions>
                                                    <p>No hay opciones</p>
                                                </template>
                                                <template v-slot:noResult>
                                                    <p>No se encuentra coincidencia</p>
                                                </template>
                                            </multiselect>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group row">
                                        <div class="col-md-6">
                                            <label for="pais"> Tipo de gasto:</label>
                                        </div>
                                        <div class="col-md-12">
                                            <multiselect
                                                v-model="valor_editar.tipo"
                                                :options="tipos" 
                                                placeholder="Seleccionar tipo" 
                                                selectLabel="Presiona para seleccionar"
                                                selectedLabel="Seleccionado"
                                                deselectLabel="Presiona para remover"
                                                >
                                                <template v-slot:noOptions>
                                                    <p>No hay opciones</p>
                                                </template>
                                                <template v-slot:noResult>
                                                    <p>No se encuentra coincidencia</p>
                                                </template>
                                            </multiselect>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group row">
                                        <div class="col-md-6">
                                            <label for="pais"> Monto del Gasto:</label>
                                        </div>
                                        <div class="col-md-12">
                                            <b-form-input v-model="valor_editar.monto" class="border-primary" @input="format_Valor"></b-form-input>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <b-button :variant="cambiar?'secondary':'primary'" @click="btn_cambiar">{{ cambiar ? 'No Cambiar' : 'Cambiar Documento'}}</b-button>
                                    <div v-if="!cambiar">
                                        <pdf :src="direccion" v-if="extension=='pdf'"></pdf>
                                        <img :src="direccion" width="100%" v-else>
                                    </div>
                                    <div class="row" v-else>
                                        <div class="col-md-12">
                                            <div class="form-group row">
                                                <div class="col-md-6">
                                                    <label for="pais"> Documento Asociado:</label>
                                                </div>
                                                <div class="col-md-12">
                                                    <b-form-file
                                                        v-model="valor_editar.imagen"
                                                        class="form-control border-primary"
                                                        accept="image/png, image/jpeg, image/jpg, application/pdf"
                                                        placeholder="Elegir Archivo"
                                                        drop-placeholder="Arrastra el archivo aquí..."
                                                        @change="obtenerImagen"
                                                        browse-text="Examinar"
                                                    ></b-form-file>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="offset-md-1 col-md-10 text-center">
                                            <figure v-if="tipoArchivo === 'imagen'">
                                                <img :src="imagenminiatura" height="auto" alt="Imagen del producto">
                                            </figure>
                                            <div v-if="tipoArchivo === 'pdf'">
                                                <pdf :src="imagenminiatura"></pdf>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </b-modal>
                    </div>
                </div>
            </div>
            <div class="col-12" v-else>
                <div class="card">
                    <div class="card-body">
                        <h4 class="text-center">No hay gastos agregados</h4>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>